/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExplainResponse } from '../../models/explain-response';

export interface AuthzExplain$Plain$Params {
  userId?: string;
  permission?: string;
}

export function authzExplain$Plain(http: HttpClient, rootUrl: string, params?: AuthzExplain$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ExplainResponse>> {
  const rb = new RequestBuilder(rootUrl, authzExplain$Plain.PATH, 'get');
  if (params) {
    rb.query('userId', params.userId, {});
    rb.query('permission', params.permission, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExplainResponse>;
    })
  );
}

authzExplain$Plain.PATH = '/api/v1/platform/authz/explain';
